module.exports = __webpack_public_path__ + "images/wechat/browser-item-984bfce34a8c3e0843cf0893fc881b58.png";